import { useState } from 'react'

import { Button, Card, Layout } from '@loadsmart/loadsmart-ui'

import { analytics } from 'legacy/utils/analytics'

import { type SpotQuote } from '../domain/SpotQuote'
import { ConfirmSubmissionDialog } from './ConfirmSubmissionDialog'
import { ShipperHeader } from './ShipperHeader'

export type SpotQuoteHeaderProps = {
  currentRate?: number
  spotQuote: SpotQuote
  onSubmit: () => void
  disabled?: boolean
}

export function SpotQuoteHeader({
  currentRate,
  spotQuote,
  disabled = false,
  onSubmit,
}: SpotQuoteHeaderProps) {
  const {
    shipper,
    quote: { stops },
  } = spotQuote
  const [isSubmitDialogOpened, setIsSubmitDialogOpened] = useState(false)

  function handleSubmitButtonClicked() {
    setIsSubmitDialogOpened(true)

    analytics.track('Spot Quote / Submit / Click', {
      id: spotQuote.uuid,
      rate: currentRate,
      quoteType: 'single',
    })
  }

  function handleConfirmSubmission() {
    onSubmit()
    setIsSubmitDialogOpened(false)

    analytics.track('Spot Quote / Submit / Dialog / Confirm', {
      id: spotQuote.uuid,
      rate: currentRate,
      quoteType: 'single',
    })
  }

  function handleCloseSubmissionDialog() {
    setIsSubmitDialogOpened(false)

    analytics.track('Spot Quote / Submit / Dialog / Cancel', {
      id: spotQuote.uuid,
      rate: currentRate,
      quoteType: 'single',
    })
  }

  return (
    <Card>
      <Card.Body>
        {isSubmitDialogOpened && (
          <ConfirmSubmissionDialog
            onConfirm={handleConfirmSubmission}
            onCancel={handleCloseSubmissionDialog}
            rate={currentRate!}
            stops={stops}
          />
        )}
        <Layout.Group align="center" justify="space-between">
          <ShipperHeader shipper={shipper} />
          <Button variant="primary" disabled={disabled} onClick={handleSubmitButtonClicked}>
            Submit
          </Button>
        </Layout.Group>
      </Card.Body>
    </Card>
  )
}
